<div class="container-fluid p-0">
  <!-- Dialog container for Kendo dialogs -->
  <div kendoDialogContainer></div>

  <div class="row main-container">
    <!-- @MF: The below is just a sample list of integrations for design and testing -->
    <div class="col-4 integrations-sidebar">
      <div class="sidebar-header">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">Integrations</h5>
        </div>

        <!-- @MF: This is a sample filter for the integrations list -->
        <!-- @MF: This will not be required until we have at least 5 or more integrations -->
        <div class="filter-container mb-3">
          <div class="filter-label mb-2">Filter by type:</div>
          <div class="filter-options">
            <button
              class="filter-btn"
              [class.active]="selectedFilter === 'all'"
              (click)="filterIntegrations('all')"
            >
              All
            </button>
            <button
              class="filter-btn data-ingestion"
              [class.active]="selectedFilter === 'data-ingestion'"
              (click)="filterIntegrations('data-ingestion')"
            >
              Data Ingestion
            </button>
            <button
              class="filter-btn ticketing"
              [class.active]="selectedFilter === 'ticketing'"
              (click)="filterIntegrations('ticketing')"
            >
              Ticketing
            </button>
          </div>
        </div>

        <hr />
      </div>
      <div class="integrations-list">
        @for (integration of integrationsList(); track integration.id) {
          @if (showIntegration(integration.id)) {
            <app-list-card
              [logo]="integration.icon"
              [icon]="integration.icon"
              [title]="integration.display_name"
              [description]="integration.description"
              [badge]="getCategoryName(integration)"
              [badgeClass]="getCategoryName(integration) === 'Data Ingestion' ? 'data-ingestion' : 'ticketing'"
              [status]="integration.status"
              [statusClass]="getStatusClass(integration.status || 'Not Configured')"
              [active]="integrationId() === integration.id"
              (cardClick)="selectIntegration(integration.id)"
            ></app-list-card>
          }
        }
      </div>
    </div>

    <!-- Integration Details Section -->
    <div class="col-8 details-container">
      <!-- @MF: Show Tenant Mapping Component when needed -->
      <!-- @MF: for integrations that support multi-tenant configuration, the tenant mapping component will be shown -->
      <!-- @MF: for example, EntraID does not support multi-tenant configuration, so the tenant mapping component will not be shown -->
      @if (mappingKind() === 'ticketing') {
        <div class="tenant-mapping-wrapper">
          <app-tenant-mapping
            [organizationId]="organizationId()"
            (close)="closeTenantMapping()"
          ></app-tenant-mapping>
        </div>
      } @else if (mappingKind() === 'ingestion') {
        @if (selectedIntegration(); as integration) {
          <div class="tenant-mapping-wrapper">
            <app-ingestor-tenant-mapping
              [organizationId]="organizationId()!"
              [integrationId]="integration.id"
              [integrationName]="integration.display_name || integration.name"
              [tenantIdLabel]="integration.tenant_id_label || 'External ID'"
              (close)="closeTenantMapping()"
            ></app-ingestor-tenant-mapping>
          </div>
        }
      } @else {
        @for (integration of integrationsList(); track integration.id) {
          @if (integrationId() === integration.id) {
            <div class="integration-details-container">
              <div class="details-header">
                <div class="integration-title">
                  <div
                    class="integration-icon large"
                    [ngClass]="getStatusClass(integration.status || 'Not Configured')"
                  ></div>
                  <div>
                    <h2>{{ integration.display_name }}</h2>
                    <div class="d-flex align-items-center">
                      <span
                        class="status-pill"
                        [ngClass]="getStatusClass(integration.status || 'Not Configured')"
                      >
                        {{ integration.status || 'Not Configured' }}
                      </span>
                      <span
                        class="integration-type-tag"
                        [ngClass]="getCategoryName(integration) === 'Data Ingestion' ? 'data-ingestion' : 'ticketing'"
                        class="ms-3"
                      >
                        {{ getCategoryName(integration) }}
                      </span>
                    </div>
                    @if (integration.documentation_url) {
                      <a
                        class="integration-guide-link"
                        [href]="integration.documentation_url"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i class="k-icon k-i-hyperlink-open me-1"></i>
                        Integration Guide
                      </a>
                    }
                  </div>
                </div>

                <div class="action-buttons">
                  <kendo-dropdownbutton
                    [data]="configOptions"
                    [svgIcon]="gearIcon"
                    (itemClick)="onConfigOptionSelect($event)"
                    [disabled]="loading()"
                  ></kendo-dropdownbutton>
                </div>
              </div>

              @if (getCategoryName(integration) === 'Data Ingestion') {
                <div class="content-card">
                  @if (isConfigured(integration.status)) {
                    <app-configured-ingestion-form
                      [organizationId]="organizationId()"
                      [integrationId]="integration.id"
                      [integrationStatus]="integration.status"
                      [integrationCategory]="getCategoryName(integration)"
                    ></app-configured-ingestion-form>
                  } @else {
                    <app-dynamic-form
                      [organizationId]="organizationId()"
                      [formGroup]="configForm"
                      [formId]="integration.id"
                      [title]="'Authentication'"
                      [testSuccess]="testSuccess"
                      [loading]="loading"
                      [testConnectionHandler]="ingestorTestHandler"
                      [icons]="{
                        checkOutline: checkOutlineIcon,
                        save: saveIcon
                      }"
                      (testConnection)="testConnection($event)"
                      (saveConfiguration)="saveIngestorConfig($event)"
                    ></app-dynamic-form>
                  }
                </div>
              } @else if (getCategoryName(integration) === 'Ticketing') {
                @if (integration.name === 'ConnectWise') {
                  <app-connectwise-form
                    [loading]="loading()"
                    [organizationId]="organizationId()"
                    [integrationId]="integration.id"
                    [integrationStatus]="integration.status"
                    [integrationDetails]="integrationDetails()"
                    [isCyflareUser]="isCyflareUser()"
                    [icons]="{
                      checkOutline: checkOutlineIcon,
                      save: saveIcon
                    }"
                    (detailPkLoaded)="onDetailPkLoaded($event)"
                    (configurationSaved)="onConfigurationSaved()"
                  ></app-connectwise-form>
                } @else if (integration.name === 'ServiceNow PSA') {
                  <app-servicenow-form
                    [loading]="loading()"
                    [icons]="{
                      checkOutline: checkOutlineIcon,
                      save: saveIcon
                    }"
                    (testConnection)="testConnection()"
                    (saveConfiguration)="saveConfiguration()"
                  ></app-servicenow-form>
                } @else {
                  @if (integration.name === 'Zoho') {
                    <div
                      class="alert alert-warning d-flex align-items-center mb-3"
                      role="alert"
                    >
                      <i class="k-icon k-i-warning me-2"></i>
                      <div>
                        This integration is only for Cyflare organization. Please don't create new Zoho integrations on
                        other companies. This is an internal integration.
                      </div>
                    </div>
                  }
                  <div class="content-card">
                    @if (isConfigured(integration.status)) {
                      <app-configured-ingestion-form
                        [organizationId]="organizationId()"
                        [integrationId]="integration.id"
                        [integrationStatus]="integration.status"
                        [integrationCategory]="getCategoryName(integration)"
                      ></app-configured-ingestion-form>
                    } @else {
                      <app-dynamic-form
                        [organizationId]="organizationId()"
                        [formGroup]="configForm"
                        [formId]="integration.id"
                        [title]="'Configuration'"
                        [testSuccess]="testSuccess"
                        [loading]="loading"
                        [testConnectionHandler]="ticketingTestHandler"
                        [icons]="{
                          checkOutline: checkOutlineIcon,
                          save: saveIcon
                        }"
                        (testConnection)="testConnection($event)"
                        (saveConfiguration)="saveTicketingConfig($event)"
                      ></app-dynamic-form>
                    }
                  </div>
                }
              }
            </div>
          }
        }

        @if (!integrationId()) {
          <div class="no-selection">
            <div class="empty-state">
              <kendo-svgicon
                [icon]="arrowLeftIcon"
                class="k-icon-xl"
              ></kendo-svgicon>
              <p>Select an integration from the sidebar</p>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
